import {slugify} from "@/lib/util";
import {useEffect, useState} from "react";

export default function Checkbox({ label, value, tag, className, onChange, filters, filterType }) {
    const labelSlugify = label !== undefined ? slugify(label) : null
    const Tag = `${tag}`
    return (
        <Tag className={className}>
            {label &&
                <>
                    <div className="flex h-6 items-center">
                        <input
                            id={labelSlugify}
                            aria-describedby={`${labelSlugify}-label`}
                            name={labelSlugify}
                            type="checkbox"
                            className="h-5 w-5 rounded-xs focus:ring-green-100 text-xs"
                            onChange={onChange}
                            checked={filters.length && filters.includes(label)}
                            data-filter-type={filterType}
                            data-value={value ? value : null}
                        />
                    </div>
                    <div className="ml-3 flex items-center leading-5 text-xs">
                        <label htmlFor={labelSlugify} id={`${labelSlugify}-label`}>
                            {label}
                        </label>
                    </div>
                </>
            }
        </Tag>
    )
}